import styled from "styled-components";

const AsyncSelectComponentStyled = styled.div`

    

`;

export default AsyncSelectComponentStyled;